import { FixedTextFieldModel } from '@types'

import { Container, Label, Value } from './SubmitterFieldFixedText.styled'

type SubmitterFieldFixedTextProps = {
  field: FixedTextFieldModel
}

export const SubmitterFieldFixedText: React.FC<SubmitterFieldFixedTextProps> = ({
  field,
}: SubmitterFieldFixedTextProps) => {
  return (
    <Container>
      <Label>{field.label}</Label>
      <Value>{field.requiredValue}</Value>
    </Container>
  )
}
